import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3214a8be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "main"
}
const _hoisted_3 = { class: "base-info van-hairline--bottom" }
const _hoisted_4 = { class: "title-line" }
const _hoisted_5 = { class: "status-item" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = { class: "info-item" }
const _hoisted_8 = { class: "info-item" }
const _hoisted_9 = {
  key: 0,
  class: "detail-check-tips"
}
const _hoisted_10 = { class: "loan-info" }
const _hoisted_11 = {
  key: 0,
  class: "not-disbursed-tips"
}
const _hoisted_12 = {
  key: 1,
  class: "overdue-locking-tips tips-wrap"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-error" }, null, -1))
const _hoisted_14 = {
  key: 2,
  class: "unbing-pay-off-tips tips-wrap"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-success" }, null, -1))
const _hoisted_16 = { class: "device-list-wrap" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "device-list" }
const _hoisted_19 = { class: "name-item" }
const _hoisted_20 = { class: "button-wrap nongfu-button-wrap" }

import { Button, Popover } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { computed, onMounted, ref, Ref } from 'vue'
import { getErrorMessage } from '@/utils/error-handle'
import { commonErrorHandle } from '@/utils/error-handle'
import { AgriculturalLoanApplyFormRouteName } from '@/defination/constant'
import type { AgriculturalLoanOrderDetail } from '@/types/agricultura-loan'
import { showToastLoading, clearToast, showConfirmModal, showNormalToast } from '@/utils/tools'
import {
  getAgriculturaLoanApplyDetail,
  requestCancelOrder,
  requestCheckQualification,
} from '@/apis/agricultura-loan'
import AppHost from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'contract-detail',
  setup(__props) {

const $route = useRoute()
const $router = useRouter()
const showPopover = ref(false)

const actions = [{ text: '撤销申请', key: '1' }]

const detail: Ref<AgriculturalLoanOrderDetail | null> = ref(null)
const showDetailCheckTips = computed(() => {
  return detail.value?.status === 3 || detail.value?.status === 4
})
const isLock = computed(() => {
  // 是否锁定-还款逾期
  return detail.value && detail.value.is_lock === 1
})
const isUnbind = computed(() => {
  // 是否解绑-贷款已结清
  return detail.value && detail.value.is_unbind === 1
})

const isWaitSign = computed(() => {
  return detail.value && detail.value?.status === 1
})
// 是否线上预授信
const isOnlinePreApproval = computed(() => {
  return detail.value && detail.value?.status === 2
})
// 是否显示撤回申请按钮
const isShowWithdrawButton = computed(() => {
  // 待完成签约且提交申请超过24小时
  return (
    (isWaitSign.value || isOnlinePreApproval.value) &&
    detail.value.create_at &&
    Date.now() - new Date(detail.value.create_at).getTime() > 86400000
  )
})
// 是否显示前往签约按钮
const isShowSignButton = computed(() => {
  return isWaitSign.value
})
// 是否显示重新申请按钮
const isShowReapplyButton = computed(() => {
  return isRefuseStatus.value
})
// 是否已拒绝的状态
const isRefuseStatus = computed(() => {
  return detail.value?.status === 5
})

const showNotDisbursedTips = computed(() => detail.value?.status === 4)
const showOverdueLockingTips = computed(() => {
  return isLock.value
})
const showUnbindPayOffTips = computed(() => isUnbind.value)
const number = $route.query.number

async function initPageDetail() {
  showToastLoading()
  try {
    const data: AgriculturalLoanOrderDetail = await getAgriculturaLoanApplyDetail(number as string)
    console.log('data', data)
    detail.value = data
  } catch (error) {
    console.log('error', error)
  }
  clearToast()
}

// 撤回申请
async function withDrawHandle() {
  try {
    await showConfirmModal({
      title: '提示',
      message: '是否确认撤销当前合同申请?',
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
    })
  } catch (error) {
    return
  }
  showToastLoading()
  try {
    await requestCancelOrder({
      number: detail.value?.number,
    })
    clearToast()
    showNormalToast('提交成功')
    setTimeout(() => {
      initPageDetail()
    }, 2000)
  } catch (error) {
    commonErrorHandle(error)
  }
}

// 前往签约操作
function toSignHandle() {
  const jump_url = detail.value?.jump_url || ''
  if (!jump_url) {
    showNormalToast('当前无有效链接')
    return
  }
  // 跳转签约操作
  AppHost.openNewPage({
    url: `${location.origin}/common-redirect-page?url=${encodeURIComponent(jump_url)}`,
    title: '惠农贷',
    showTopBar: true,
  })
}

// 重新申请
async function reApplyHanlde() {
  showToastLoading()
  try {
    const data = await requestCheckQualification()
    clearToast()

    if (data?.is_qualified) {
      $router.replace({
        name: AgriculturalLoanApplyFormRouteName,
      })
    } else {
      showConfirmModal({
        title: '提示',
        message: data.message,
        confirmButtonText: '知道了',
        className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
        showCancelButton: false,
      })
    }
  } catch (error) {
    const message = getErrorMessage(error)
    clearToast()
    showConfirmModal({
      title: '提示',
      message,
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
      showCancelButton: false,
    })
  }
}

function onActionSelect(value: { text: string; key: string }) {
  if (value?.key === '1') {
    withDrawHandle()
  }
}

onMounted(() => {
  initPageDetail()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "合同详情",
      rightUseSlot: ""
    }, {
      right: _withCtx(() => [
        (_unref(isShowWithdrawButton))
          ? (_openBlock(), _createBlock(_unref(Popover), {
              key: 0,
              show: showPopover.value,
              "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showPopover).value = $event)),
              placement: "bottom-end",
              theme: "dark",
              actions: actions,
              onSelect: onActionSelect,
              "show-arrow": false
            }, {
              reference: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["show"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (detail.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, "贷款合同号: " + _toDisplayString(detail.value?.contract_number || '-'), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(detail.value?.status_text || ''), 1)
            ]),
            _createElementVNode("div", _hoisted_6, "申请时间：" + _toDisplayString(detail.value?.create_at || ''), 1),
            _createElementVNode("div", _hoisted_7, "最终贷款金额：¥" + _toDisplayString(detail.value?.actual_loan_amount || ''), 1),
            _createElementVNode("div", _hoisted_8, "申请期限： " + _toDisplayString(detail.value?.apply_deadline || ''), 1),
            (_unref(showDetailCheckTips))
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*合约详情请前往农行APP查询"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_unref(showNotDisbursedTips))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "*货款放款请往农行APP操作放款"))
              : _createCommentVNode("", true),
            (_unref(showOverdueLockingTips))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createTextVNode("还款逾期，合约机被锁定，请及时还款 ")
                ]))
              : _createCommentVNode("", true),
            (_unref(showUnbindPayOffTips))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createTextVNode("贷款已结清，合约机已解绑 ")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, " 合约机（" + _toDisplayString(detail.value?.sn_list?.length) + "/" + _toDisplayString(detail.value?.sn_list?.length) + "） ", 1),
              _createElementVNode("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value?.sn_list || [], (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.serial_number
                  }, [
                    _createElementVNode("div", null, "设备编码: " + _toDisplayString(item.serial_number), 1),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(item.name), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (detail.value)
      ? (_openBlock(), _createBlock(CommonFooterWrap, { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              (_unref(isShowSignButton))
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    size: "mini",
                    round: "",
                    class: "confirm-button xa-vant-button",
                    onClick: toSignHandle
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("前往签约")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(isShowReapplyButton))
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 1,
                    plain: "",
                    size: "mini",
                    round: "",
                    class: "reapply-button xa-vant-button",
                    onClick: reApplyHanlde
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重新申请")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})